import * as constants from 'helper/constants';
import * as EmailValidator from 'email-validator';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import strings from 'helper/localization/localization';

import MockAPI from 'helper/mockApi'; // for prop-types
import API from '../../api/api'; // for prop-types

export default class ChangeEmail extends PureComponent {
  constructor(props) {
    super(props);

    // Properties
    this.api = this.props.api;
    this.user = this.props.user;
    this.updateUser = this.props.updateUser;

    // State
    this.state = {
      newEmail: '',
      newEmailConfirmation: '',
      errorMessage: null,
      emailChanged: false,
      loadingStatus: null,
    };

    // Bindings
    this.newEmailSubmit = this.newEmailSubmit.bind(this);
    this.newEmailChange = this.newEmailChange.bind(this);
    this.newEmailConfirmationChange = this.newEmailConfirmationChange.bind(this);
  }

  newEmailChange(e) {
    this.setState({ newEmail: e.target.value });
  }

  newEmailConfirmationChange(e) {
    this.setState({ newEmailConfirmation: e.target.value });
  }

  newEmailSubmit(e) {
    e.preventDefault();
    this.setState({ errorMessage: null });

    // Emails must match
    const emailsMatch = this.state.newEmail === this.state.newEmailConfirmation;
    if (!emailsMatch) {
      this.setState({ errorMessage: strings.errorEmailDoesntMatch });
      return false;
    }

    // Must be a valid email address
    const validEmail = EmailValidator.validate(this.state.newEmail);
    if (!validEmail) {
      this.setState({ errorMessage: strings.errorEmailInvalid });
      return false;
    }

    // Send email off to be updated
    this.setState({ loadingStatus: constants.api.loading });
    const email = this.state.newEmail;

    this.api.updateEmail({ email }, (api) => {
      if (api.status === constants.api.success) {
        this.user.email = email;
        this.updateUser(this.user);
        this.setState({
          emailChanged: true,
          loadingStatus: api.status,
        });
      } else {
        this.setState({ loadingStatus: api.status });
      }
    });

    return true;
  }

  render() {
    const errorMessage = this.state.errorMessage ?
      <p className="text-danger">{this.state.errorMessage}</p> : null;

    const formDisabled = this.state.loadingStatus === constants.api.loading ? { disabled: 'disabled' } : {};

    const formContent = (
      <form onSubmit={this.newEmailSubmit}>
        <div className="modal-body">
          <div className="form-group" id="second-form-group">
            <label htmlFor="new-email">{strings.newEmailAddress}</label>
            <input type="email" className="form-control" id="new-email" onChange={this.newEmailChange} {...formDisabled} required />
          </div>
          <div className="form-group">
            <label htmlFor="new-email-repeat">{strings.repeatNewEmailAddress}</label>
            <input type="email" className="form-control" id="new-email-repeat" onChange={this.newEmailConfirmationChange} {...formDisabled} required />
          </div>
          { errorMessage }
        </div>
        <div className="modal-footer d-block">
          <button
            type="submit"
            id="email-change--submit"
            className="btn btn-block mb-0 btn-primary"
            {...formDisabled}
          >
            {strings.changeMyEmail}
          </button>
          <button type="button" className="btn btn-outline-secondary btn-block" data-dismiss="modal">{strings.cancel}</button>
        </div>
      </form>
    );

    const completedContent = (
      <div>
        <div className="modal-body">
          <p id="email-changed--confirmation">{strings.yourRequestWasSent}</p>
          <p>{strings.emailConfirmation}</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary" data-dismiss="modal">{strings.close}</button>
        </div>
      </div>
    );

    const currentEmail = !this.state.emailChanged ? (
      <div className="modal-body" id="modal-current">
        <label htmlFor="new-email">{strings.currentEmail}</label>
        <input type="email" className="form-control current-email" id="current-email" onKeyPress="return false;" value={this.user.email} />
      </div>
    ) : null;

    const bodyContent = this.state.emailChanged ? completedContent : formContent;

    return (
      <div className="modal fade" id="changeEmailModal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="change-email--title">{strings.changeMyEmail}</h5>
            </div>
            { currentEmail }
            { bodyContent }
          </div>
        </div>
      </div>
    );
  }
}

ChangeEmail.propTypes = {
  /** api object used to update email value */
  api: PropTypes.oneOfType([
    PropTypes.instanceOf(API),
    PropTypes.instanceOf(MockAPI),
  ]).isRequired,
  /** api call to update user email value */
  updateUser: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/accountManagement/ChangeEmail.jsx